<template>
  <Bar
    id="my-chart-bar"
    :options="chartOptions"
    :data="chartData"
    :width="width"
  />
</template>

<script>
import { Bar } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const realValues = [
      18.5,
      15.56,
      14.72,
      13.43,
      "11.10",
      10.11,
      4.25,
      3.21,
      3.06,
      1.92,
      1.8,
      0.59,
      0.5,
    ];

    return {
      chartData: {
        // type: "bar",
        labels: [
          "Rádio + DG",
          "TV aberta + DG",
          "Shows/Festivais",
          "Streaming (VOD)",
          "TV assinatura",
          "Streaming (Áudio)",
          ["Sonorização", "Ambiental"],
          "Casas Festas",
          ["Música ao vivo", "(casas pequenas)"],
          "Carnaval",
          "Cinema",
          "Serviços Digitais",
          "Festa Junina",
        ],
        datasets: [
          {
            backgroundColor: [
              "rgba(236,22,81, 1)",
              "rgba(226,22,81, 0.9)",
              "rgba(236,22,81, 0.8)",
              "rgba(236,22,81, 0.7)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.5)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.5)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.6)",
            ],
            data: realValues.map((value, index) => {
              if (index === realValues.length - 1 || index === realValues.length - 2) {
                return 1.55;
              } else {
                return value;
              }
            }),
            borderWidth: 0,
          },
        ],
      },
      chartOptions: {
        indexAxis: "y",
        scales: {
          y: {
            ticks: {
              autoSkip: false,
              color: "#EC1651",
              font: {
                size: 11,
                family: "sanuk-bold",
              },
            },
          },
        },
        plugins: {
          tooltip: {
            displayColors: true,
            backgroundColor: "#FFF",
            bodyColor: "#000",
            titleColor: " #000",
            padding: 10,
            callbacks: {
              title: (items) => {
                return items[0].label.replaceAll(",", " ");
              },
              label: (x) => {
                return `${String(realValues[x.dataIndex]).replaceAll(
                  ".",
                  ",",
                )}%`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            color: "white",
            font: (context) => {
              const isLastTwo =
                context.dataIndex >= context.dataset.data.length - 2;
              return { size: isLastTwo ? 12 : 12 };
            },
            formatter: function (value, context) {
              return (
                String(realValues[context.dataIndex]).split(".").join(",") + "%"
              );
            },
          },
        },
        animation: {
          animateScale: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        hoverOffset: 5,
      },
    };
  },
};
</script>
